import { JSX } from "react";
import { ScheduledQualificationsHeader } from "./components/ScheduledQualificationsHeader";
import { ScheduledQualificationsContent } from "./components/ScheduledQualificationsContent";

export const ScheduledQualificationsPageContainer = (): JSX.Element => {
    return (
        <div className="p-scheduled-qualifications">
            <ScheduledQualificationsHeader />
            <ScheduledQualificationsContent />
        </div>
    );
};
